import { ApiResult } from "common/models";
import { put, takeLatest } from "redux-saga/effects";
import { UserService } from "../user.service";
import { userActions } from "../user.slice";

/**
 *
 * @param action
 */
const getUserAvatar = function* () {
  const profileImage: ApiResult<Blob> = yield UserService.getUserImage();
  try {
    yield put({
      type: userActions.getUserAvatarSuccess.type,
      payload: profileImage?.value
        ? URL.createObjectURL(profileImage.value)
        : ""
    });
  } catch (e) {
    yield put({
      type: userActions.getUserAvatarSuccess.type,
      payload: ""
    });
  }
};

const getUserAvatarWatch = function* () {
  yield takeLatest(userActions.getUserProfile.type, getUserAvatar);
};

export { getUserAvatarWatch };
